import React, {useState} from 'react'
import {withStyles, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import TextInput from 'components/TextInput';
import GridBlock from 'components/GridBlock';
import INPUT_TYPE from 'constants/INPUT_TYPE'
import getObjectValue from "libs/getObjectValue";
import Tr from 'translations/Translations';

const style = theme => ({
    root: {},
    text: {
        marginLeft: theme.spacing(2),
    }
})

function WadiumField(
    {
        classes,
        formikProps,
        index,
    }) {

    const id = `dealings.${index}.value`;
    const estimatedNetValueId = `dealings.${index}.estimatedNetValue`;
    const warningThreshold = getObjectValue('warningThreshold', formikProps.values, 1);

    const isWarning = (guaranteeValue) => {
        let estimatedNetValue = getObjectValue(estimatedNetValueId, formikProps.values, null);

        if (!estimatedNetValue || guaranteeValue === null) {
            return true;
        }

        return warningThreshold * estimatedNetValue < guaranteeValue;
    }

    const [warning, setWarning] = useState(() => isWarning(getObjectValue(id, formikProps.values, null)));


    const change = (val) => {
        let number = parseFloat(val);
        setWarning(isWarning(number));
    }

    return (<>
            <GridBlock wrap='nowrap' alignItems='center'>
                <TextInput
                    formikProps={formikProps}
                    id={id}
                    noErrorSpace
                    type={INPUT_TYPE.NUMBER_POSITIVE_AMOUNT}
                    onChange={change}

                />
                <Typography
                    variant='body1'
                    className={classes.text}
                >
                    PLN
                </Typography>
            </GridBlock>
            {warning && <Typography variant='body2' color='textSecondary'>
                {Tr('valuebiggerthanthreshold', {value: (warningThreshold * 100)})}
            </Typography>}
        </>
    )
}

WadiumField.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(WadiumField);